import axios from "axios";
import router from "@/router";
import alert from "@/plugins/AlertMessages.js";

const panelXios = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});
panelXios.defaults.headers.common["Content-Type"] = "application/json";
panelXios.defaults.headers.common["Authorization"] =
  "Bearer " + localStorage.panelToken;

export default {
  // Members Authentications -------------------------------------------------------
  login({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/LoginMember", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("authUser", res.data);
        localStorage.setItem("panelToken", res.data.access_token);
        panelXios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.access_token;
        router.push({ name: "PanelDashboard" });
        commit("setSuccess", alert.success.login, { root: true });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  sendRegisterCode({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/Register", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.codeSent,
            redirect: false,
          },
          { root: true }
        );
        commit("setRegisterCode", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  submitRegisterCode({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/Authentication", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("setRegisterAuth", res.data.data);
        localStorage.setItem("panelToken", res.data.data.access_token);
        panelXios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.data.access_token;
        router.push({ name: "PanelDashboard" });
        commit("setSuccess", alert.success.register, { root: true });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  completeRegisteration({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .post("Account/CompleteRegistration", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        commit("authUser", res.data.data);
        const payload = {
          access_token: null,
          isNew: false,
        };
        commit("setRegisterAuth", payload);
        localStorage.setItem("panelToken", res.data.data.access_token);
        panelXios.defaults.headers.common["Authorization"] =
          "Bearer " + res.data.data.access_token;
        commit("setSuccess", alert.success.completeRegister, { root: true });
        router.push({ name: "PanelProfile" });
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  forgotPassword({ commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/ForgotPassword", data)
      .then(() => {
        commit("setSuccess", alert.success.codeSent, { root: true });
        commit("setForgotCheck", true);
        setTimeout(() => {
          commit("setForgotCheck", false);
        }, 800);
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          if (
            error.response.data.message &&
            error.response.data.message == "یافت نشد"
          ) {
            commit("setError", alert.error.mobileNotFound, { root: true });
          } else if (
            error.response.data.message &&
            error.response.data.message != "یافت نشد"
          ) {
            const errMsg =
              error.response.data.message + " ثانیه دیگر مجدد امتحان کنید";
            commit("setError", errMsg, { root: true });
          } else {
            commit("setError", alert.error.server, { root: true });
          }
        } else {
          commit("setError", alert.error.server, { root: true });
        }
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  resetPassword({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    axios
      .post("Account/ResetPassword", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.changePassword,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  logout({ commit }) {
    localStorage.removeItem("panelToken");
    panelXios.defaults.headers.common["Authorization"] = "";
    commit("clearAuth");
    router.push({ name: "UserLogin" });
  },

  // Profile Actions -------------------------------------------------------------------------------
  getProfile({ dispatch, commit }) {
    panelXios
      .get("member/Profile")
      .then((res) => {
        commit("setProfile", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  editProfile({ dispatch }, data) {
    panelXios
      .put("member/Profile", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editPassword({ dispatch }, data) {
    panelXios
      .put("member/Profile/changePassword", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  editAvatar({ dispatch }, data) {
    panelXios
      .post("member/Profile", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  deleteAvatar({ dispatch }) {
    panelXios
      .delete("member/Profile")
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // User's Companies Actions
  getCompanies({ dispatch, commit }) {
    panelXios
      .get("member/Company")
      .then((res) => {
        commit("setCompanies", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCompany({ dispatch, commit }, data) {
    panelXios
      .get("member/Company/" + data)
      .then((res) => {
        commit("setCompany", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  printCompany({ dispatch, commit }, data) {
    panelXios
      .get("member/Company/print/" + data)
      .then((res) => {
        commit("setPrintCompany", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .post("member/Company", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  editCompany({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .put("member/Company/" + data.id, data.value)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.edit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  deleteCompany({ dispatch, commit }, data) {
    panelXios
      .delete("member/Company/" + data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        commit("setLoadingBtn", false, { root: true });
      });
  },

  // Invoice Form Options actions
  getBillSubjects({ dispatch, commit }) {
    panelXios
      .get("member/Invoice/LoadSubjects")
      .then((res) => {
        commit("setBillSubjects", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBillTypes({ dispatch, commit }) {
    panelXios
      .get("member/Invoice/LoadBillTypes")
      .then((res) => {
        commit("setBillTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBillPatterns({ dispatch, commit }, data) {
    panelXios
      .get("member/Invoice/LoadBillPatterns?billTypeId=" + data)
      .then((res) => {
        commit("setBillPatterns", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBuyerTypes({ dispatch, commit }) {
    panelXios
      .get("member/Invoice/LoadBuyerTypes")
      .then((res) => {
        commit("setBuyerTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getFlightTypes({ dispatch, commit }) {
    panelXios
      .get("member/Invoice/LoadFlightTypes")
      .then((res) => {
        commit("setFlightTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getClearingMethods({ dispatch, commit }) {
    panelXios
      .get("member/Invoice/LoadClearingMethods")
      .then((res) => {
        commit("setClearingMethods", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPaymentTypes({ dispatch, commit }) {
    panelXios
      .get("member/Invoice/LoadPaymentTypes")
      .then((res) => {
        commit("setPaymentTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getUnitMeasurements({ dispatch, commit }) {
    panelXios
      .get("member/Invoice/LoadUnitMeasurement")
      .then((res) => {
        commit("setUnitMeasurements", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getCurrencyTypes({ dispatch, commit }) {
    panelXios
      .get("member/Invoice/LoadCurrencyTypes")
      .then((res) => {
        commit("setCurrencyTypes", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  // Tax Invoices Actions
  getInvoices({ dispatch, commit }, data) {
    panelXios
      .get(
        "member/Invoice/LoadInvoices?companyId=" +
          data +
          "&pageNumber=1&pageSize=100000"
      )
      .then((res) => {
        commit("setInvoices", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
  getInvoiceById({ dispatch, commit }, data) {
    panelXios
      .get("member/Invoice/" + data)
      .then((res) => {
        commit("setInvoiceById", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  addInvoice({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .post("member/Invoice", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  createInvoice({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .post("member/Invoice/CreateInvoice", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  inquiryInvoice({ dispatch, commit }, data) {
    commit("setInquiryInvoice", []);
    panelXios
      .post("member/Invoice/Inquiry/" + data)
      .then((res) => {
        commit("setInquiryInvoice", res.data.data);
        commit("setInquiryCheck", true);
        setTimeout(() => {
          commit("setInquiryCheck", false);
        }, 800);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  cancelInvoice({ dispatch }, data) {
    panelXios
      .post("member/Invoice/Cancel", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  downloadInvoiceFile({ commit, dispatch }, data) {
    panelXios
      .get("member/Invoice/download/" + data)
      .then((res) => {
        commit("setInvoiceFileLink", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  printInvoice({ dispatch, commit }, data) {
    panelXios
      .get("member/Invoice/print/" + data)
      .then((res) => {
        commit("setPrintAddress", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  deleteInvoice({ dispatch }, data) {
    panelXios
      .post("member/Invoice/delete", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.delete,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Wallet and Transactions Actions
  getTransactions({ dispatch, commit }) {
    panelXios
      .get("member/Wallet/transactions")
      .then((res) => {
        commit("setTransactions", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getWallet({ dispatch, commit }) {
    panelXios
      .get("member/Wallet")
      .then((res) => {
        commit("setWallet", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  chargeWallet({ dispatch, commit }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .post("member/Wallet/Charge", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("setPaymentGateway", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  verifyPayment({ dispatch, commit }, data) {
    panelXios
      .post("member/Wallet/VerifyPayment", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("setPaymentResult", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      });
  },

  // Tax Key Actions
  getTaxKeys({ dispatch, commit }) {
    panelXios
      .get("member/Key")
      .then((res) => {
        commit("setTaxkeys", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  setTaxKey({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .post("member/Key", data)
      .then((res) => {
        dispatch(
          "successPOSTHandler",
          {
            server: res,
            message: alert.success.submit,
            redirect: false,
          },
          { root: true }
        );
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  exportPublicKey({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .post("member/Key/ExportPublicKey", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("setPublicKeyLink", res.data.data);
        setTimeout(() => {
          commit("setPublicKeyLink", null);
        }, 1000);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  createKeyByPfx({ commit, dispatch }, data) {
    commit("setLoadingBtn", true, { root: true });
    panelXios
      .post("member/Key/CreateByPfx", data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        commit("setPfxResult", res.data.data);
      })
      .catch((error) => {
        dispatch("errorPOSTHandler", error, { root: true });
      })
      .finally(() => {
        setTimeout(() => {
          commit("setLoadingBtn", false, { root: true });
        }, 1000);
      });
  },

  getTaxKeyByNational({ commit }, data) {
    panelXios
      .get("member/Key/Get?nationalId=" + data)
      .then((res) => {
        commit("setTaxkeyByNational", res.data.data);
      })
      .catch();
  },

  getCompanyFinalPrice({ commit }, data) {
    panelXios
      .get("member/Company/CompanyFinalPrice?" + data)
      .then((res) => {
        commit("setCompanyFinalPrice", res.data.data);
      })
      .catch();
  },
};
